import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import validator from 'validator';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import api from '../../services/api';

import 'bootstrap/scss/bootstrap.scss';
import './style/form.scss';

import loader from '../../img/icon-loading.gif';

class FormUser extends Component {
	state = {
		isAdmin: false,
	}

	formDefaults = {
		name: {
			value: '', isValid: true, message: '', input: 'nome',
		},
		email: {
			value: '', isValid: true, message: '', input: 'email',
		},
		password: {
			value: '', isValid: true, message: '', input: 'senha',
		},
		confirmPassword: {
			value: '', isValid: true, message: '', input: 'confirmação de senha',
		},
	};

	showPassword = {
		typeAttrPassword: 'password',
		typeAttrPasswordConfirm: 'password',
		classIconPassword: '',
		classIconPasswordConfirm: '',
	};

	requestAPI = {
		responseApiUser: '',
		classResponse: '',
		fieldDisable: false,
		redirectToUsers: false,
	};

	state = {
		...this.formDefaults,
		...this.showPassword,
		...this.requestAPI,
	};

	componentWillReceiveProps(nextProps) {
		const { user } = this.props;

		this.updateForm(nextProps.formValues);

		if (user.data) {
			user.data.relationships.roles.map((role) => {
				if (role.name === 'admin') {
					return this.setState({
						isAdmin: true,
					});
				}

				return false;
			});
		}
	}

	updateForm = (values) => {
		this.setState({
			name: { value: values.name },
			email: { value: values.email },
		});
	};

	submitUserToApi = () => {
		const {
			name,
			email,
			password,
			confirmPassword,
		} = this.state;

		const { apiUri, apiMethod } = this.props;

		const data = {
			name: name.value,
			email: email.value,
			password: password.value,
			password_confirm: confirmPassword.value,
		};

		for (const dataKey in data) {
			if (!data[dataKey]) {
				delete data[dataKey];
			}
		}

		const that = this;

		that.setState({
			responseApiUser: '',
			fieldDisable: true,
		});

		api[apiMethod](apiUri, data)
			.then(() => {
				const { messageSuccess } = this.props;
				that.setState({
					responseApiUser: messageSuccess,
					classResponse: 'success',
					redirectToUsers: true,
				});
			})
			.catch((e) => {
				const responseData = e.response.data;
				const errors = responseData
					? responseData.errors.map(error => error.message).join('\n')
					: 'Falha no envio, tente mais tarde';

				this.setState({
					responseApiUser: errors,
					classResponse: 'danger',
				});
			})
			.then(() => {
				this.setState({
					fieldDisable: false,
				});
			});
	};

	onChange = (e) => {
		const state = {
			...this.state,
			[e.target.name]: {
				...this[e.target.name],
				value: e.target.value,
			},
		};

		this.setState(state);
	};

	onSubmit = (e) => {
		e.preventDefault();
		this.resetValidationStates();
		if (this.formIsValid()) {
			this.submitUserToApi();
		}
	};

	formIsValid = () => {
		const {
			name,
			email,
			password,
			confirmPassword,
		} = this.state;

		const fields = [name, email, password, confirmPassword];
		let isGood = true;

		this.resetFields(fields);

		if (validator.isEmpty(name.value)) {
			name.isValid = false;
			name.message = '* O campo nome não foi preenchido.';
			isGood = false;
		}

		if (!validator.isEmail(email.value)) {
			email.isValid = false;
			email.message = '* O email digitado não é válido.';
			isGood = false;
		}

		if (!validator.equals(password.value, confirmPassword.value)) {
			password.isValid = false;
			confirmPassword.isValid = false;
			password.message = '* As senhas precisam ser iguais.';
			isGood = false;
		}

		fields.map((field) => {
			if (validator.isEmpty(field.value) && field.required) {
				field.isValid = false;
				field.message = `* O campo ${field.input} não pode ser vazio.`;
				isGood = false;
			}

			return field;
		});

		if (!isGood) {
			this.setState({
				name,
				email,
				password,
				confirmPassword,
				formInvalid: true,
			});
		}

		return isGood;
	};

	resetFields = (fields) => {
		fields.map((field) => {
			field.isValid = false;
			field.message = '';

			return field;
		});
	};

	resetValidationStates = () => {
		const state = JSON.parse(JSON.stringify(this.state));

		const hasBarProperty = Object.prototype.hasOwnProperty.call(state, 'isValid');

		Object.keys(state).map((key) => {
			if (hasBarProperty) {
				state[key].isValid = true;
				state[key].message = '';
			}
			return state[key];
		});

		return this.setState(state);
	};

	toggleEnabledPassword(icon) {
		const { classIconPassword, classIconPasswordConfirm } = this.state;

		this.setState({ classIconPassword: '', typeAttrPassword: 'password' });

		if (icon === 'icon-password' && classIconPassword === '') {
			this.setState({ classIconPassword: 'fa-eye-slash', typeAttrPassword: 'text' });
		}

		this.setState({ classIconPasswordConfirm: '', typeAttrPasswordConfirm: 'password' });

		if (icon === 'icon-password-confirm' && classIconPasswordConfirm === '') {
			this.setState({ classIconPasswordConfirm: 'fa-eye-slash', typeAttrPasswordConfirm: 'text' });
		}
	}

	render() {
		const {
			name,
			email,
			password,
			confirmPassword,
			fieldDisable,
			typeAttrPassword,
			typeAttrPasswordConfirm,
			classIconPassword,
			classIconPasswordConfirm,
			responseApiUser,
			classResponse,
			formInvalid,
			redirectToUsers,
			isAdmin,
		} = this.state;

		const { apiMethod } = this.props;
		const btnText = apiMethod === 'post' ? 'Criar usuário' : 'Atualizar usuário';
		const passRequired = apiMethod === 'post';

		const nameGroupClass = classNames('form-group',
			{ 'has-error': !name.isValid });
		const emailGroupClass = classNames('form-group',
			{ 'has-error': !email.isValid });
		const passwordGroupClass = classNames('form-group',
			{ 'has-error': !password.isValid });
		const confirmGroupClass = classNames('form-group',
			{ 'has-error': !confirmPassword.isValid });

		return (
			<Fragment>
				<form className="form-signin">
					<div className="content-form row">
						<div className={`form-group col-md-12 text-left ${nameGroupClass}`}>
							<label htmlFor="name" className="labelFormUser">Nome</label>
							<input
								type="text"
								name="name"
								className={`form-control ${(formInvalid && name.message !== '')
									? 'is-invalid' : ''}`}
								value={name.value}
								onChange={this.onChange}
								disabled={fieldDisable}
								required="required"
							/>

							<div className="help-block">{name.message}</div>
						</div>

						<div className={`form-group col-md-12 text-left ${emailGroupClass}`}>
							<label htmlFor="name" className="labelFormUser">E-mail</label>
							<input
								type="email"
								name="email"
								className={`form-control toggle-password ${(formInvalid
									&& email.message !== '') ? 'is-invalid' : ''}`}
								value={email.value}
								onChange={this.onChange}
								disabled={fieldDisable}
								required="required"
								readOnly={!isAdmin}
							/>

							<div className="help-block">{email.message}</div>
						</div>

						<div className={`form-group col-md-6 text-left ${passwordGroupClass}`}>
							<div className="container-password">
								<label htmlFor="name" className="labelFormUser">Senha</label>
								<input
									type={typeAttrPassword}
									name="password"
									className={`form-control remove-icon ${(formInvalid
										&& password.message !== '') ? 'is-invalid' : ''}`}
									value={password.value}
									onChange={this.onChange}
									disabled={fieldDisable}
									required={passRequired}
								/>

								<span
									role="button"
									tabIndex="-1"
									toggle="#password-field" 
									className={`fa fa-fw fa-eye field-icon toggle-password
																	${classIconPassword}`}
									onClick={this.toggleEnabledPassword.bind(this, 'icon-password')}
									onKeyDown={this.toggleEnabledPassword.bind(this, 'icon-password')}
								/>
								<div className="help-block">{password.message}</div>
							</div>
						</div>

						<div className={`form-group col-md-6 text-left ${confirmGroupClass}`}>
							<div className="container-password">
								<label htmlFor="name" className="labelFormUser">Confirmar senha</label>
								<input
									type={typeAttrPasswordConfirm}
									name="confirmPassword"
									className={`form-control remove-icon ${(formInvalid
										&& confirmPassword.message !== '') ? 'is-invalid' : ''}`}
									value={confirmPassword.value}
									onChange={this.onChange}
									id="confirm-password-field"
									disabled={fieldDisable}
									required={passRequired}
								/>

								<div className="help-block">{confirmPassword.message}</div>

								<span
									role="button"
									tabIndex="-1"
									toggle="#confirm-password-field" 
									className={`fa fa-fw fa-eye field-icon toggle-password
																	${classIconPasswordConfirm}`}
									onClick={this.toggleEnabledPassword.bind(this, 'icon-password-confirm')}
									onKeyDown={this.toggleEnabledPassword.bind(this, 'icon-password-confirm')}
								/>
							</div>
						</div>
					</div>

					<button
						className="btn btn-secondary w-100 mt-3"
						type="submit"
						onClick={this.onSubmit.bind(this)}
						disabled={fieldDisable}
					>
						{fieldDisable ? <img src={loader} alt="" /> : btnText}
					</button>
				</form>

				{
					redirectToUsers === true ? (
						<Redirect to={{
							pathname: '/backoffice/usuarios',
							state: { formMessage: responseApiUser },
						}}
						/>
					) : ''
				}

				{classResponse !== ''
					? (
						<div
							className={`response-create-account mt-3 alert alert-${classResponse}`}
						>
							{responseApiUser}
						</div>
					)
					: ''}
			</Fragment>
		);
	}
}

const mapStateToProps = state => ({
	user: state.user,
});

export default connect(mapStateToProps)(FormUser);
